// extracted by mini-css-extract-plugin
export default {"logoContainer":"PacientePasswordReset_logoContainer__PtFdP","logo":"PacientePasswordReset_logo__Z5aP+"};